import {
  createUnitTypeOptions,
  WORKING_DECLARATION_LABEL_KEYS,
  UNIT_TYPES,
} from '@/config/unitTypes.constants';

// Inbound shipments add a tracking unit on top of the shared working/declaration pair.
export const { unitTypeLabel, buildRowUnitOptions, buildUnitHeaderOptions } = createUnitTypeOptions(
  {
    ...WORKING_DECLARATION_LABEL_KEYS,
    [UNIT_TYPES.tracking]: 'UNIT_TRACKING',
  },
);
